import React, { useCallback, useState } from 'react';
import styles from './order-toolbar.module.sass';
import DatePicker from 'componets/date-picker';
import Button from 'componets/button';
import { SELECT_DATE_RANGE, useOrderToolbar } from './use-order-toolbar';
import analytics from 'service/analytics';
import { isInOneMonth } from 'helpers/date-helper';
import { CheckIcon } from 'icons';

const SEND_STATUS_DEFAULT = 'idle';

export const OrderToolbar = ({ startAt, endAt }) => {
  const { state, email, dispatch, sendUserReport } = useOrderToolbar(startAt, endAt);
  // idle | pending | success | error
  const [sendStatus, setSendStatus] = useState(SEND_STATUS_DEFAULT);
  const [errorMessage, setErrorMessage] = useState('');

  const onClickDatePicker = () => analytics.track('消費頁_選取時間_click');

  const reset = useCallback(() => {
    setSendStatus(SEND_STATUS_DEFAULT);
    setErrorMessage('');
  }, []);

  const onDateSelected = useCallback(
    dateRange => {
      reset();

      dispatch({
        type: SELECT_DATE_RANGE,
        payload: dateRange,
      });
    },
    [dispatch, reset]
  );

  const onExport = useCallback(async () => {
    analytics.track('消費頁_匯出_click');

    if (!isInOneMonth(state.startAt, state.endAt)) {
      setErrorMessage('匯出區間以一個月為上限，請修改日期後重新匯出');
      return;
    }

    setSendStatus('pending');
    try {
      await sendUserReport(state);
      setSendStatus('success');
    } catch (err) {
      console.log(err);
      setSendStatus('error');
      return;
    }
  }, [sendUserReport, state]);

  const isInvalid = !!errorMessage;

  return (
    <div className={styles['order-toolbar']}>
      <div className={styles['order-toolbar__list-item']}>
        <p className={styles['order-toolbar__list-item__title']}>匯出日期</p>
        <DatePicker
          isInvalid={isInvalid}
          onClickDatePicker={onClickDatePicker}
          dateRange={{
            startAt: state.startAt,
            endAt: state.endAt,
          }}
          onDateSelected={onDateSelected}
        />
        {isInvalid && <small className={styles['order-toolbar__list-item__error-message']}>{errorMessage}</small>}
      </div>
      <div className={styles['order-toolbar__list-item']}>
        <p className={styles['order-toolbar__list-item__title']}>寄送信箱</p>
        <p className={styles['order-toolbar__list-item__value']}>{email}</p>
      </div>
      <Button
        variant="default"
        style={{
          alignSelf: 'flex-end',
          marginTop: '24px',
        }}
        leftIcon={sendStatus === 'success' ? <CheckIcon /> : null}
        loading={sendStatus === 'pending'}
        onClick={onExport}
      >
        {sendStatus === 'success' ? '已送出' : '匯出'}
      </Button>
    </div>
  );
};
